import Lenis from "lenis";

let lenis = null;

export function initLenis() {
    if (lenis) return lenis;
    lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    const raf = (time) => {
        lenis.raf(time);
        requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return lenis;
}

export function scrollToId(id) {
    const el = document.querySelector(id);
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    else el.scrollIntoView({ behavior: "smooth" });
}

export function prefillService(name) {
    window.dispatchEvent(new CustomEvent("prefill-service", { detail: name }));
}

export function discussService(name) {
    prefillService(name);
    scrollToId("#contact");
}
